import { gradients } from "../foundations/semanticTokens";

/** Drawer (mobile sidebar): navy gradient content, white round close button, body is a flex column with no padding. */
export const Drawer = {
  baseStyle: {
    overlay: { bg: "surface.overlay", backdropFilter: "blur(4px)", WebkitBackdropFilter: "blur(4px)" },
    dialog: {
      bg: gradients.sidebar,
      color: "white",
      borderRightRadius: "xl",
      boxShadow: "xl",
    },
    closeButton: {
      color: "white",
      borderRadius: "full",
      top: 4,
      right: 4,
      _hover: { bg: "whiteAlpha.200" },
      _focusVisible: { boxShadow: "outlineOnDark" },
    },
    header: { p: 0 },
    body: { p: 0, display: "flex", flexDirection: "column" },
    footer: { p: 0 },
  },
};
